module.exports = __webpack_public_path__ + "img/collect.d07b212a.svg";